@if (strategy) {
  <div class="sequential">
    <h3>Sequential-strategy</h3>
    <mat-form-field>
      <mat-label>Enter the strategy title</mat-label>
      <input matInput type="text" placeholder="" [(ngModel)]="strategy.title" autocomplete="off">
    </mat-form-field>
    <!-- <div class="children">
    <div class="child-row" *ngFor="let child of strategy.children; let ix = index;">
      <div class="icon" *ngIf="ix > 0 && ix < strategy.children.length">
        <mat-icon>linear_scale</mat-icon>
      </div>
      <div class="step" [class.current-step]="ix === currentStepIndex">
        <app-strategy [strategy]="child"></app-strategy>
      </div>
    </div>
  </div> -->
</div>
}